// API Configuration
export const API_BASE_URL = 'https://api.carsavenue.com/api';

// Google sign-in is hidden until the client's Google project lists carsavenue.com.
// Flip to true to bring the button back on the login and register pages.
export const GOOGLE_LOGIN_ENABLED = false;

// Google OAuth Configuration
export const GOOGLE_CLIENT_ID = '1084029839129-r1hfsppjhkr5use6sm3tt4v0vr8mdt8f.apps.googleusercontent.com';

// OAuth Redirect URI
export const GOOGLE_REDIRECT_URI = 'https://carsavenue.com/login';

// Google OAuth Scopes
export const GOOGLE_SCOPES = 'profile email openid';